import {
    Alert,
    AlertDescription,
    AlertIcon,
    Box,
    Button,
    Checkbox,
    CloseButton,
    Flex,
    FormControl,
    FormLabel,
    HStack,
    Input,
    Stack,
    Text,
    useDisclosure,
    VStack
} from "@chakra-ui/react";
import React, {useState} from "react";
import isEmail from 'validator/lib/isEmail';

import {getFormattedPhoneNum, getPhoneNumberValue} from "../../../utils/formatUtils";
import useFormField from "../../hooks/useFormField";
import useShoppingCart from "../../hooks/useShoppingCart";
import CreditCardForm from "../CreditCardForm/CreditCardForm";
import PoliciesDrawer from "../PoliciesDrawer/PoliciesDrawer";

function PaymentForm() {
    const {executeShoppingCart} = useShoppingCart()

    const {isOpen, onOpen, onClose} = useDisclosure()
    const btnRef = React.useRef()

    const [errorMessage, setErrorMessage] = useState('')

    const [isTermsAndConditionsAccepted, setIsTermsAndConditionsAccepted] = useState(false)
    const [firstName, setFirstName, isFirstNameValid, firstNameOnFocusReceiver, shouldShowFirstNameError] = useFormField('')
    const [lastName, setLastName, isLastNameValid, lastNameOnFocusReceiver, shouldShowLastNameError] = useFormField('')
    const [email, setEmail, isEmailValid, emailOnFocusReceiver, shouldShowEmailError] = useFormField('', (str = '') => isEmail(str))
    const [phoneNumber, setPhoneNumber, isPhoneNumberValid, phoneNumberOnFocusReceiver, shouldShowPhoneNumberError] = useFormField('', (str) => getPhoneNumberValue(str).length === 10)

    const isFormInformationComplete = isFirstNameValid && isLastNameValid && isEmailValid && isPhoneNumberValid && isTermsAndConditionsAccepted

    return (
        <>
            {errorMessage && <Stack spacing={3}>
                <Alert status='error'>
                    <AlertIcon/>
                    <AlertDescription>{errorMessage}</AlertDescription>
                    <CloseButton onClick={() => setErrorMessage('')} position='absolute' right='8px' top='8px'/>
                </Alert>
            </Stack>}

            <Flex direction='row'>
                <Box width={4}>
                    <Text fontSize='lg' fontWeight="bold">2.</Text>
                </Box>
                <Box width='100%'>
                    <Text fontSize='lg' fontWeight="bold"> Enter Payment Details </Text>
                    <VStack direction='column' pt={2}>
                        <HStack spacing={{base: '2', md: '4'}} width='100%'>
                            <FormControl isInvalid={shouldShowFirstNameError} onFocus={firstNameOnFocusReceiver}
                                         isRequired>
                                <FormLabel htmlFor='first-name' fontWeight='bold'>First name</FormLabel>
                                <Input value={firstName} onChange={({target: {value}}) => setFirstName(value)}
                                       id='first-name' placeholder='First name'/>
                            </FormControl>
                            <FormControl isInvalid={shouldShowLastNameError} onFocus={lastNameOnFocusReceiver}
                                         isRequired>
                                <FormLabel htmlFor='last-name' fontWeight='bold'>Last name</FormLabel>
                                <Input value={lastName} onChange={({target: {value}}) => setLastName(value)}
                                       id='last-name'
                                       placeholder='Last name'/>
                            </FormControl>
                        </HStack>
                        <HStack spacing={{base: '2', md: '4'}} width='100%'>
                            <FormControl isInvalid={shouldShowEmailError} onFocus={emailOnFocusReceiver} isRequired>
                                <FormLabel htmlFor='email' fontWeight='bold'>Email</FormLabel>
                                <Input value={email} onChange={({target: {value}}) => setEmail(value)} id='email'
                                       placeholder='Email'/>
                            </FormControl>
                            <FormControl isInvalid={shouldShowPhoneNumberError}
                                         isRequired>
                                <FormLabel htmlFor='phone' fontWeight='bold'>Phone Number</FormLabel>
                                <Input value={getFormattedPhoneNum(phoneNumber)} onChange={({target: {value}}) => {
                                    phoneNumberOnFocusReceiver()
                                    setPhoneNumber(value)
                                }}
                                       id='phone' placeholder='Phone Number'/>
                            </FormControl>
                        </HStack>
                        <Box w='100%'>
                            <CreditCardForm
                                isFormInformationComplete={isFormInformationComplete}
                                setErrorMessage={setErrorMessage}
                                onNonceGeneratedSuccessfully={(nonce) => {
                                    executeShoppingCart({
                                        nonce,
                                        email,
                                        firstName,
                                        lastName,
                                        phoneNumber: getPhoneNumberValue(phoneNumber),
                                    }).catch((error) => {
                                        setErrorMessage(error)
                                    })
                                }}
                            >
                                <FormControl isRequired>
                                    <FormLabel htmlFor='phone' fontWeight='bold'>Terms & Conditions</FormLabel>
                                    <Checkbox isChecked={isTermsAndConditionsAccepted}
                                              onChange={({target: {checked}}) => setIsTermsAndConditionsAccepted(checked)}>
                                        I accept <Button ref={btnRef} onClick={onOpen} variant='link'>Policies and Terms
                                        & Conditions</Button> to authorize charges
                                    </Checkbox>
                                    {isOpen && <PoliciesDrawer onClose={onClose} btnRef={btnRef}/>}
                                </FormControl>
                            </CreditCardForm>
                        </Box>
                    </VStack>
                </Box>
            </Flex>
        </>
    )
}

export default PaymentForm